module.exports = __webpack_public_path__ + "img/iguana-tatuada-780.692715b8.webp";